import Decimal from "decimal.js";

import type { VectorD3 } from "../vector";

export abstract class WCollider {
  location: VectorD3;

  constructor(
    location: VectorD3,
    public rotation: Decimal
  ) {
    this.location = location.clone();
  }

  // Misc

  abstract clone(): WCollider;

  // Position

  setLocationAndRotation(location: VectorD3, rotation: Decimal) {
    this.location.copy(location);
    this.rotation = rotation;

    this.updatePoints();
  }

  setLocation(location: VectorD3) {
    this.location.copy(location);

    this.updatePoints();
  }

  setRotation(rotation: Decimal) {
    this.rotation = rotation;

    this.updatePoints();
  }

  rotate(angle: Decimal) {
    this.rotation = this.rotation.plus(angle);

    this.updatePoints();
  }

  abstract updatePoints(): void;

  // Collisions

  abstract contains(collider: WCollider): boolean;
  abstract isContained(collider: WCollider): boolean;
  abstract overlaps(collider: WCollider): boolean;
  abstract getBox(): Box;
  abstract createExpanded(distance: Decimal): WCollider;
  abstract getPoints(): VectorD3[];
  abstract getLocalPoints(): VectorD3[];
  abstract distanceTo(collider: WCollider): Decimal;

  getNearest(colliders: WCollider[]) {
    let distance = Decimal(Infinity);
    let i = 0;
    for(const c of colliders) {
      const d = this.distanceTo(c);
      if(d.lessThan(distance)) {
        distance = d;
        i = colliders.indexOf(c);
      }
    }
    return colliders[i];
  }
}

export class Box {
  constructor(
    public left: Decimal,
    public right: Decimal,
    public top: Decimal,
    public bottom: Decimal
  ) { }
}
